<script setup>
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
});

const modelValue = defineModel({ type: Boolean, default: false });
</script>

<template>
  <div
    class="flex flex-col items-start w-full border rounded-xl border-n-weak bg-n-solid-1 [interpolate-size:allow-keywords]"
  >
    <div class="flex flex-col items-start w-full gap-1 px-4 py-3.5">
      <div class="flex items-center justify-between w-full gap-3">
        <span class="text-heading-3 text-n-slate-12">
          {{ header }}
        </span>
        <template v-if="hideToggle">
          <slot name="hiddenToggle">
            <div class="size-2" />
          </slot>
        </template>
        <ToggleSwitch v-else v-model="modelValue" />
      </div>
      <span v-if="description" class="text-body-main text-n-slate-11">
        {{ description }}
      </span>
    </div>
    <div
      v-if="$slots.editor"
      class="w-full border-t rounded-b-xl border-n-weak bg-n-alpha-1"
      :class="{ 'p-0': compact, 'px-4 pb-4 pt-3': !compact }"
    >
      <slot name="editor" />
    </div>
  </div>
</template>
